


















  import { Vue, Component, Prop } from 'vue-property-decorator';
import { UiSearchResultItem } from './ui-search-result-item';
  import { getPageLocationByHref } from '@/app/shared/utils/route-utils';
  import BreadcrumbComponent from '@/app/breadcrumb/components/breadcrumb-component.vue';

  @Component({
    components: {
      BreadcrumbComponent
    }
  })
  export default class SearchResultItemComponent extends Vue {
    @Prop()
    public href: string;

    @Prop()
    public result: UiSearchResultItem;

    public get location() {
      return getPageLocationByHref(this.href);
    }
  }
